import styled from "styled-components";
import { size, palette } from "styled-theme";

const Wrapper = styled.div`
  display: ${(props) => (props.$bannerexists ? "flex" : "none")};
  overflow: hidden;
  justify-content: ${(props) => (props.$closeable ? "space-between" : "center")};
  gap: 25px;
  background-color: ${palette("color", 32)};
  padding: 10px 0;
  width: 100%;
  animation-duration: 0.7s;
  animation-name: ${(props) => (props.$showbanner ? "" : "slideoutbanner")};
  animation-fill-mode: forwards;

  a {
    color: ${palette('color', 30)}
  }

  .messages-group {
    display: flex;
    flex-direction: column;
    gap: 7px;
    color: white;
  }

  .message-content-title {
    font-weight: bold;
    padding-left: 15px;
    color: ${palette("color", 34)};

    @media only screen and (min-width: ${size("M")}) {
      text-align: center;
      padding-left: 0;
    }
  }

  .message-content-secondary {
    padding-left: 15px;

    @media only screen and (min-width: ${size("M")}) {
      text-align: center;
      padding-left: 0;
    }
  }

  @keyframes slideoutbanner {
    from {
      max-height: 60px;
      padding: 5px 0;
      opacity: 1;
    }
    to {
      max-height: 0px;
      padding: 0;
      opacity: 0;
    }
  }

  @media only screen and (min-width: ${size("M")}) {
    gap: 10px;
  }

  .empty-div {
    display: none;
    width: 1px;
    margin-left: 1px;

    @media only screen and (min-width: ${size("M")}) {
      display: block;
      margin-left: 15px;
      width: 25px;
    }
  }

  .message-content, .message-content-secondary {
    color: white;
    text-align: justify;
    padding-left: 15px;
    padding-right: ${(props) => (props.$closeable ? "0px" : "15px")};

    @media only screen and (min-width: ${size("M")}) {
      padding-left: 0px;
      text-align: center;
    }
  }

  .close-button {
    width: 22px;
    height: 22px;
    margin: 10px 15px 0 0;
    align-self: flex-start;
    align-items: center;
    text-align: center;
    animation-duration: 0.7s;
    animation-name: ${(props) => (props.$showbanner ? "" : "slideoutbutton")};
    animation-fill-mode: forwards;
    cursor: pointer;

    @keyframes slideoutbutton {
      from {
        max-height: 60px;
        opacity: 1;
      }
      to {
        max-height: 0px;
        opacity: 0;
      }
    }

    svg {
      font-size: 20px;
      color: white;

      :hover {
        color: white;
        background-color: none;
      }
    }

    @media only screen and (min-width: ${size("M")}) {
      align-self: center;
      margin: 0 15px 0 0;
    }
  }
`;

export default Wrapper;
